import { LooseObject } from '@milo/types/index';
import queryString from 'query-string';

export const formatGetParams: (getParams: LooseObject) => string = (getParams) => {
  return queryString.stringify(getParams);
};
